import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-cYellow focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-terteiry/20 text-text",
        secondary:
          "border-transparent bg-cSage text-cGreen",
        destructive:
          "border-transparent bg-cDenied text-cError",
        warning:
          "border-transparent bg-amber-100 text-amber-800",
        success:
          "border-transparent bg-cLightGreen text-cSuccess",
        outline: "text-text border-cMediumGrey",
        category:
          "border-transparent bg-terteiry/20 text-text/80 text-sm py-[2px] px-[6px] rounded-[6px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
